import { Observable } from 'rxjs';

import { CvTemplate } from 'domain/template/cv/cv-template';

export abstract class CvTemplateRepositoryPort {
	public abstract saveCvTemplates(entities: CvTemplate[]): Promise<void>;

	public abstract observeCvTemplates(
		organizationId: string
	): Observable<CvTemplate[]>;
}
